import { BaseService } from "../BaseService";
import { EventBaseService } from "./EventBaseService";
import { AuthService } from "../auth/auth.service";
import { environment } from '../../../../src/environments/environment';
import { HttpClient } from "@angular/common/http";
import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable, of, throwError } from "rxjs";
import { catchError, concatMap, delay, map, retryWhen, take } from 'rxjs/operators';
import { ApiResult } from "../../models/ApiResult";
import { EventModel } from "../../models/api/EventModel";
import { EventFindResultModel } from "../../models/api/EventFindResultModel";

@Injectable({
    providedIn: 'root'
})

export class EventService extends EventBaseService {

    constructor(private h: HttpClient, private r: Router, private a: AuthService) {
        super(h, r, a);
    };

  /// <summary>
  /// FIND: Retrieves a list of Event records from the database
  /// /Event
  /// </summary>
  public getActiveEvents(): Observable<EventModel[]> {
    // Find Event Records

    const url = `${super.getBaseUrl()}/active`;

    if (!environment.production)
      console.log("Get Active Events: Calling " + url);

    return this.h.get<EventModel[]>(url)
      .pipe(
        map(next => {
          for (var i = 0; i < next.length; i++) {
            let o: EventModel = Object.assign(new EventModel(), next[i]);
            next[i] = o;
          }

          return next;
        }),
        retryWhen(errors =>
          errors.pipe(
            concatMap((error, count) => {
              console.log("ERROR", error);
              if (count > this.RETRY_CEILING) return throwError(error);
              return this.tokenCheckAndRefresh(error);
            }),
            delay(1000),
          ),
        ),
        catchError(this.errorHandler)
      );
  }

  public getLiveEvents(): Observable<EventModel[]> {
    // Find Event Records

    const url = `${super.getBaseUrl()}/live`;

    if (!environment.production)
      console.log("Get Live Events: Calling " + url);

    return this.h.get<EventModel[]>(url)
      .pipe(
        map(next => {
          for (var i = 0; i < next.length; i++) {
            let o: EventModel = Object.assign(new EventModel(), next[i]);
            next[i] = o;
          }

          return next;
        }),
        retryWhen(errors =>
          errors.pipe(
            concatMap((error, count) => {
              console.log("ERROR", error);
              if (count > this.RETRY_CEILING) return throwError(error);
              return this.tokenCheckAndRefresh(error);
            }),
            delay(1000),
          ),
        ),
        catchError(this.errorHandler)
      );
  }


}
